import apiClient from "./ApiService";
import {  PATH_COMMERCE_ACTIVITY } from "../config/env";

export const getCommerceActivity = async()=>{
    return await apiClient.get(PATH_COMMERCE_ACTIVITY);
}
export default getCommerceActivity;